import React, { forwardRef } from 'react';
import { Label, Checkbox as RebassCheckbox } from '@rebass/forms';
import type { CheckboxProps as RebassCheckboxProps } from '@rebass/forms';
import type { SxStyleProp } from 'rebass';
import { useColors } from '../../hooks/useColors';
import { Box } from '../Box';
import Icon from '../Icon';
import { faMinusSquare } from '@fortawesome/pro-solid-svg-icons/faMinusSquare';

export type CheckboxProps = RebassCheckboxProps & {
  label: React.ReactNode;
  labelSx?: SxStyleProp;
  indeterminate?: boolean;
};

export const Checkbox = forwardRef(
  ({ label, labelSx, indeterminate, ...rest }: CheckboxProps, ref) => {
    const colors = useColors();
    return (
      <Label
        sx={{
          ...labelSx,
          ':hover': {
            cursor: 'pointer',
          },
          '&:has(input:focus-visible)': {
            outline: `2px solid ${colors['blue']}`,
            borderRadius: '2px',
          },
          '& svg:first-of-type': {
            color: indeterminate ? `${colors['gray30']}` : `${colors['blue']}`,
          },
        }}
      >
        {indeterminate && (
          <Box width={24} height={24} mr={2}>
            <Icon
              style={{
                width: '100%',
                height: '100%',
              }}
              icon={faMinusSquare}
            />
          </Box>
        )}

        <RebassCheckbox
          ref={ref}
          {...rest}
          sx={{
            backgroundColor: 'transparent !important',
            ...(indeterminate && {
              display: 'none',
              'input:checked ~ &': {
                display: 'none',
              },
            }),
            ...rest.sx,
          }}
        />

        {label}
      </Label>
    );
  },
);

Checkbox.displayName = 'Checkbox';
